export default "__VITE_ASSET__8dc85b53__"